

import React from 'react';

import './style.css'


interface IModalProps {
    icon: string,
    message: string,
    isOpen: boolean,
    onYes: () => void,
    onNo: () => void,
    buttonYesText: string,
}

const ConfirmModal: React.FC<IModalProps> = ({icon, message, buttonYesText, isOpen = false, onYes, onNo,  }) => {


    if (!isOpen) {
        return null;
      }
    
      return (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className='center-middle'>
                <div className="icon-size-2">
                    <img className="responsive-image" src={icon} />
                </div>
            </div>
            <br />
            <div className='center-middle font-size-17px'>
                {message}
             </div>
            <br />
            <div className="center-middle">
                <button type="button" className='btn-green-2 center-middle' onClick={onYes} >{buttonYesText}</button>
                &nbsp;  &nbsp;
                <button type="button" className='btn-white-green-2 center-middle' onClick={onNo} >Cancel</button>
            </div>
          </div>
        </div>
      );

}

export default ConfirmModal;